var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.41634 14.7338V21.1666H10.583V14.7338C14.8578 15.2668 18.1663 18.9133 18.1663 23.3333H0.833008C0.833044 21.2223 1.60346 19.1839 2.99968 17.6006C4.3959 16.0173 6.32193 14.9979 8.41634 14.7338ZM9.49967 13.5833C5.90842 13.5833 2.99967 10.6746 2.99967 7.08331C2.99967 3.49206 5.90842 0.583313 9.49967 0.583313C13.0909 0.583313 15.9997 3.49206 15.9997 7.08331C15.9997 10.6746 13.0909 13.5833 9.49967 13.5833Z",
    fill: "currentFill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormal);
export default __webpack_public_path__ + "static/media/formal.8561b6da7e6f20618e5d31aabb35ddea.svg";
export { ForwardRef as ReactComponent };